import React, { useMemo, useState, useEffect, useCallback } from "react";

import { API_BASE } from "../config";


/* ===========================
   RENDEZ-VOUS
=========================== */
export function RendezVousMedecin({ user }) {
  const token = user?.token;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [q, setQ] = useState("");
  const [statut, setStatut] = useState("");
  const [periode, setPeriode] = useState("upcoming");
  const [typeRdv, setTypeRdv] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);

  const [total, setTotal] = useState(0);
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  const headers = useMemo(
    () => ({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token || ""}`,
    }),
    [token]
  );

  const resetMessages = useCallback(() => {
    setError("");
    setSuccess("");
  }, []);

  const formatDateFr = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleDateString("fr-FR", { year: "numeric", month: "2-digit", day: "2-digit" });
  };

  const formatHeureFr = (iso) => {
    if (!iso) return "—";
  
    return new Date(iso).toLocaleTimeString("fr-FR", {
      timeZone: "Europe/Paris",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const startOfTodayMs = () => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d.getTime();
  };

  const endOfTodayMs = () => {
    const d = new Date();
    d.setHours(23, 59, 59, 999);
    return d.getTime();
  };

  const fetchRdv = useCallback(async () => {
    if (!token) return;
    resetMessages();
    setLoading(true);

    try {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("limit", String(limit));
      if (q.trim()) params.set("q", q.trim());
      if (statut) params.set("statut", statut);
      if (periode && periode !== "all") params.set("periode", periode);
      if (typeRdv) params.set("type", typeRdv);

      const res = await fetch(`${API_BASE}/medecin/rendezvous?${params.toString()}`, { headers });
      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setError(data.msg || "Erreur lors du chargement des rendez-vous");
        setItems([]);
        setTotal(0);
        return;
      }

      setItems(data.items || []);
      setTotal(Number(data.total || 0));
    } catch {
      setError("Impossible de contacter le serveur.");
    } finally {
      setLoading(false);
    }
  }, [token, headers, page, limit, q, statut, periode, typeRdv, resetMessages]);

  useEffect(() => {
    fetchRdv();
  }, [fetchRdv]);

  const filtered = items;




  const totalPages = useMemo(() => {
    const t = Number(total || 0);
    const l = Number(limit || 20);
    return Math.max(1, Math.ceil(t / l));
  }, [total, limit]);

  const badgeClass = (s) => {
    if (s === "CONFIRME") return "badgeOk";
    if (s === "ANNULE") return "badgeBad";
    return "badgeNeutral";
  };

  const onSearchSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    fetchRdv();
  };
  const MOTIFS_ANNULATION = [
    "Raison personnelle",
    "Raison professionnelle",
    "Raison familiale",
    "Raison logistique",
    "Autre raison",
  ];
  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [cancelTarget, setCancelTarget] = useState(null); // rdv sélectionné pour annulation
  const [cancelMotif, setCancelMotif] = useState("");

  const annulerRdv = useCallback(async () => {
    if (!token || !cancelTarget?.id) return;
  
    resetMessages();
    setLoading(true);
  
    try {
      const res = await fetch(`${API_BASE}/medecin/rendezvous/${cancelTarget.id}/annuler`, {
        method: "POST",
        headers,
        body: JSON.stringify({ motif_annulation: cancelMotif }),
      });
  
      const data = await res.json().catch(() => ({}));
  
      if (!res.ok) {
        setError(data.msg || "Erreur annulation");
        return;
      }
  
      // ✅ Mise à jour directe dans la liste (sans attendre refresh)
      setItems((prev) =>
        prev.map((x) =>
          x.id === cancelTarget.id
            ? { ...x, statut: "ANNULE", motif_annulation: cancelMotif }
            : x
        )
      );
  
      // ✅ Si le modal "Voir" est ouvert sur ce RDV, on le met à jour aussi
      setSelected((prev) =>
        prev?.id === cancelTarget.id
          ? { ...prev, statut: "ANNULE", motif_annulation: cancelMotif }
          : prev
      );
  
      setCancelModalOpen(false);
      setCancelTarget(null);
      setCancelMotif("");
    } catch {
      setError("Impossible de contacter le serveur.");
    } finally {
      setLoading(false);
    }
  }, [token, headers, cancelTarget, cancelMotif, resetMessages]);
  


  return (
<div className="adminPanel rdvPage">
<div className="adminPanelHeader">
        <div>
 
        </div>

      
      </div>

      {error && <div className="adminError"> {error}</div>}
      {success && <div className="adminSuccess">{success}</div>}

     
     
      <div className="adminCard adminCardSpan" style={{ marginBottom: 14 }}>
        <div className="adminCardHeader">
        </div>

        <form onSubmit={onSearchSubmit} style={{ display: "grid", gap: 10 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
            <label className="field">
              <div className="fieldLabel">Recherche</div>
              <div className="input">
                <input
                  className="inputControl"
                  placeholder="Référence, code bénéficiaire, email…"
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                />
              </div>
            </label>

            <label className="field">
              <div className="fieldLabel">Statut</div>
              <div className="input">
                <select
                  className="inputControl"
                  value={statut}
                  onChange={(e) => {
                    setStatut(e.target.value);
                    setPage(1);
                  }}
                >
                  <option value="">Tous</option>
                  <option value="CONFIRME">Confirmés</option>
                  <option value="ANNULE">Annulés</option>
                </select>
              </div>
            </label>

            <label className="field">
              <div className="fieldLabel">Type</div>
              <div className="input">
                <select
                  className="inputControl"
                  value={typeRdv}
                  onChange={(e) => {
                    setTypeRdv(e.target.value);
                    setPage(1);
                  }}
                >
                  <option value="">Tous</option>
                  <option value="collectivite">Collectivité</option>
                  <option value="usager">Usager direct</option>
                </select>
              </div>
            </label>
          </div>

          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
            <button type="button" className={`btnSecondary btnCompact ${periode === "upcoming" ? "isActiveTab" : ""}`} onClick={() => setPeriode("upcoming")}>
              À venir
            </button>
            <button type="button" className={`btnSecondary btnCompact ${periode === "today" ? "isActiveTab" : ""}`} onClick={() => setPeriode("today")}>
              Aujourd’hui
            </button>
            <button type="button" className={`btnSecondary btnCompact ${periode === "past" ? "isActiveTab" : ""}`} onClick={() => setPeriode("past")}>
              Passés
            </button>
            <button type="button" className={`btnSecondary btnCompact ${periode === "all" ? "isActiveTab" : ""}`} onClick={() => setPeriode("all")}>
              Tout
            </button>

            <div style={{ flex: 1 }} />

            <button className="btnPrimary btnCompact" type="submit" disabled={loading}>
              Rechercher
            </button>
          </div>
        </form>
      </div>

      <div className="adminCard adminCardSpan">
        <div className="adminCardHeader">
          <div className="adminCardTitle">Liste</div>
          <div className="adminCardDesc">
            {loading ? "Chargement…" : `${filtered.length} résultat(s) sur cette page (total: ${total})`}
          </div>
        </div>

        {filtered.length ? (
          <div style={{ overflowX: "auto" }}>
            <table className="adminTable" style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0 }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", padding: 12 }}>Date</th>
                <th style={{ textAlign: "left", padding: 12 }}>Heure</th>
                <th style={{ textAlign: "left", padding: 12 }}>Bénéficiaire</th>

                {/* ✅ NOUVEAU */}
                <th style={{ textAlign: "left", padding: 12 }}>Collectivité</th>

                <th style={{ textAlign: "left", padding: 12 }}>Référence</th>
                <th style={{ textAlign: "left", padding: 12 }}>Statut</th>
                <th style={{ textAlign: "center", padding: 40 }}>Actions</th>
              </tr>
            </thead>

                      <tbody>
            {filtered.map((it) => (
              <tr key={it.id} style={{ borderTop: "1px solid rgba(0,0,0,0.06)" }}>
                <td data-label="Date" style={{ padding: 12, whiteSpace: "nowrap" }}>
                  {formatDateFr(it.debut)}
                </td>

                <td data-label="Heure" style={{ padding: 12, whiteSpace: "nowrap" }}>
                  {formatHeureFr(it.debut)} → {formatHeureFr(it.fin)}
                </td>

                <td data-label="Bénéficiaire" style={{ padding: 12 }}>
                  <div style={{ fontWeight: 600 }}>
                    {(it.beneficiaire_nom || it.beneficiaire_prenom)
                      ? `${it.beneficiaire_nom || ""} ${it.beneficiaire_prenom || ""}`.trim()
                      : "—"}
                  </div>
                  {it.beneficiaire_code && (
                    <div className="adminMuted" style={{ fontSize: 13 }}>
                      Code : {it.beneficiaire_code}
                    </div>
                  )}
                </td>

                <td data-label="Collectivité" style={{ padding: 12 }}>
                  <div style={{ fontWeight: 600 }}>{it.collectivite_nom || "—"}</div>
                </td>

                <td data-label="Référence" style={{ padding: 12, whiteSpace: "nowrap" }}>
                  {it.reference || "—"}
                </td>

                <td data-label="Statut" style={{ padding: 12 }}>
                  <span className={`statusBadge ${badgeClass(it.statut)}`}>{it.statut || "—"}</span>
                </td>

                <td data-label="Actions" className="rdvMedecinActionsCell" style={{ padding: 12 }}>
                  <button className="btnSecondary btnCompact" onClick={() => setSelected(it)}>
                    Voir
                  </button>
                  <button
                    className="btnDangerOutline btnCompact"
                    type="button"
                    disabled={loading || it.statut === "ANNULE"}
                    onClick={() => {
                      setCancelTarget(it);
                      setCancelMotif("");
                      setCancelModalOpen(true);
                    }}
                    title={it.statut === "ANNULE" ? "Déjà annulé" : "Annuler ce rendez-vous"}
                  >
                    Annuler
                  </button>
                </td>
              </tr>
            ))}
          </tbody>

            </table>
            {cancelModalOpen && (
  <div className="logoutModalOverlay">
    <div className="logoutModal" style={{ maxWidth: 450 }}>
      <div className="logoutModalTitle">Annuler le rendez-vous</div>
      <div className="logoutModalText">
        Choisis un motif d’annulation. Le RDV passera à <b>ANNULE</b>.
      </div>

      <div style={{ marginTop: 14, display: "grid", gap: 10 }}>
        <div className="adminCard" style={{ margin: 0 }}>
          <div className="adminMuted" style={{ fontSize: 13 }}>
            RDV : <b>{cancelTarget?.reference || "—"}</b> <br/>
            <br />
            {formatDateFr(cancelTarget?.debut)} — {formatHeureFr(cancelTarget?.debut)} →{" "}
            {formatHeureFr(cancelTarget?.fin)}
          </div>
        </div>

        <label className="field">
          <div className="fieldLabel">Motif d’annulation</div>
          <div className="input">
            <select
              className="inputControl"
              value={cancelMotif}
              onChange={(e) => setCancelMotif(e.target.value)}
            >
              <option value="">— Sélectionner un motif —</option>
              {MOTIFS_ANNULATION.map((m) => (
                <option key={m} value={m}>
                  {m}
                </option>
              ))}
            </select>
          </div>
        </label>
      </div>

      {error && <div className="adminError">⚠️ {error}</div>}

            <div className="logoutModalActions">
              <button
                className="btnSecondary"
                type="button"
                onClick={() => {
                  setCancelModalOpen(false);
                  setCancelTarget(null);
                  setCancelMotif("");
                }}
                disabled={loading}
              >
                Fermer
              </button>

              <button
                className="btnDanger"
                type="button"
                disabled={loading || !cancelMotif}
                onClick={annulerRdv}
              >
                {loading ? "Annulation..." : "Confirmer l’annulation"}
              </button>
            </div>
          </div>
        </div>
      )}


            <div style={{ display: "flex", gap: 10, justifyContent: "space-between", alignItems: "center", padding: 12 }}>
              <div className="adminMuted" style={{ fontSize: 13 }}>
                Page {page} / {totalPages}
              </div>

              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <select
                  className="inputControl"
                  value={limit}
                  onChange={(e) => {
                    setLimit(Number(e.target.value));
                    setPage(1);
                  }}
                  style={{ width: 110 }}
                >
                  <option value={10}>10 / page</option>
                  <option value={20}>20 / page</option>
                  <option value={50}>50 / page</option>
                </select>

                <button className="btnSecondary btnCompact" type="button" disabled={loading || page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>
                  Précédent
                </button>
                <button className="btnSecondary btnCompact" type="button" disabled={loading || page >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>
                  Suivant
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="adminPlaceholder">
            <div className="adminPlaceholderTitle">Aucun rendez-vous</div>
            <ul className="adminList">
              <li>Essayez un autre filtre (statut/période) ou une autre recherche.</li>
            </ul>
          </div>
        )}
      </div>

      {selected && (
  <div className="logoutModalOverlay">
    <div className="logoutModal" style={{ maxWidth: 920 }}>
      <div className="logoutModalTitle">Détails du rendez-vous</div>
      <div className="logoutModalText">Informations du RDV sélectionné.</div>

      <div style={{ marginTop: 14, display: "grid", gap: 10 }}>
        {/* ✅ Carte Résumé */}
        <div className="adminCard" style={{ margin: 0 }}>
          <div style={{ display: "grid", gap: 6 }}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
              <div style={{ fontWeight: 700 }}>{selected.reference || "—"}</div>
              <span className={`statusBadge ${badgeClass(selected.statut)}`}>
                {selected.statut || "—"}
              </span>
            </div>

            <div className="adminMuted" style={{ fontSize: 13 }}>
              {formatDateFr(selected.debut)} — {formatHeureFr(selected.debut)} →{" "}
              {formatHeureFr(selected.fin)}
            </div>

          </div>
        </div>

        {/* ✅ Carte Bénéficiaire */}
        <div className="adminCard" style={{ margin: 0 }}>
          <div style={{ fontWeight: 700, marginBottom: 8 }}>Bénéficiaire</div>

          <div>
            {(selected.beneficiaire_nom || selected.beneficiaire_prenom)
              ? `${selected.beneficiaire_nom || ""} ${selected.beneficiaire_prenom || ""}`.trim()
              : "—"}
          </div>

          <div className="adminMuted" style={{ fontSize: 13, marginTop: 6 }}>
            Code : {selected.beneficiaire_code || "—"}
          </div>

          <div style={{ marginTop: 6 }}>{selected.beneficiaire_email || "—"}</div>

          {selected.beneficiaire_telephone && (
            <div className="adminMuted" style={{ fontSize: 13 }}>
              {selected.beneficiaire_telephone}
            </div>
          )}
        </div>

        {/* ✅ Carte Collectivité */}
        <div className="adminCard" style={{ margin: 0 }}>
          <div style={{ fontWeight: 700, marginBottom: 8 }}>Collectivité</div>
          <div>{selected.collectivite_nom || "—"}</div>
        </div>
      </div>
      {selected.statut === "ANNULE" && (
        <div className="adminError" style={{ marginTop: 10 }}>
          <b>Motif d’annulation :</b> {selected.motif_annulation || "—"}
        </div>
      )}
      <div className="logoutModalActions">
        <button className="btnSecondary" type="button" onClick={() => setSelected(null)}>
          Fermer
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
}